(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["installment-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('installment-calculator')) return;

    class InstallmentCalculator extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[ref="slider"]');
        this.monthsLabel = this.querySelector('[ref="monthsLabel"]');
        this.amount = this.querySelector('[ref="amount"]');
        this.providers = this.querySelectorAll('[data-provider]');

        this.monthsSuffix = this.dataset.monthsLabel || '';
        this.perMonthSuffix = this.dataset.suffix || '';
        this.moneyFormat = this.dataset.moneyFormat || '{{ amount }}';

        this.boundOnInput = this.onInput.bind(this);
        if (this.slider) {
          this.slider.addEventListener('input', this.boundOnInput);
        }

        this.providers.forEach((button) => {
          button.addEventListener('click', () => {
            this.providers.forEach((b) => b.classList.remove('is-active'));
            button.classList.add('is-active');
          });
        });

        this.boundOnVariantUpdate = this.onVariantUpdate.bind(this);
        const closestSection = this.closest('.shopify-section, dialog');
        if (closestSection) {
          closestSection.addEventListener('variant:update', this.boundOnVariantUpdate);
        }

        this.render();
      }

      disconnectedCallback() {
        if (this.slider) {
          this.slider.removeEventListener('input', this.boundOnInput);
        }
        const closestSection = this.closest('.shopify-section, dialog');
        if (closestSection) {
          closestSection.removeEventListener('variant:update', this.boundOnVariantUpdate);
        }
      }

      onVariantUpdate(event) {
        const resource = event.detail && event.detail.resource;
        if (resource && typeof resource.price === 'number') {
          this.dataset.price = String(resource.price);
          this.render();
        }
      }

      onInput() {
        this.render();
      }

      formatMoney(cents) {
        const value = (cents / 100).toFixed(2);
        const parts = value.split('.');
        const formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        if (this.moneyFormat.indexOf('{{amount}}') > -1) {
          return this.moneyFormat.replace('{{amount}}', formatted);
        }
        if (this.moneyFormat.indexOf('{{ amount }}') > -1) {
          return this.moneyFormat.replace('{{ amount }}', formatted);
        }
        return this.moneyFormat.replace(/\{\{[^}]*\}\}/, formatted);
      }

      render() {
        if (!this.slider) return;

        const months = Number(this.slider.value) || Number(this.slider.min) || 1;
        const min = Number(this.slider.min) || 1;
        const max = Number(this.slider.max) || min;
        const price = Number(this.dataset.price) || 0;
        const monthly = price / months;

        const percent = max > min ? ((months - min) / (max - min)) * 100 : 0;
        this.style.setProperty('--value-percent', percent + '%');

        if (this.monthsLabel) {
          this.monthsLabel.textContent = months + ' ' + this.monthsSuffix;
        }
        if (this.amount) {
          this.amount.textContent = this.formatMoney(monthly) + this.perMonthSuffix;
        }
      }
    }

    customElements.define('installment-calculator', InstallmentCalculator);
  })();
  } catch(e) { console.error(e); }
})();

})();
